module.exports = __webpack_public_path__ + "static/media/level-3-blue.8e094d42.svg";